
import ImgLogoATSH from "../../assets/img/atsh/logo.png";

/*
  Params: 
  @image: pass image (not url)
  @classNames: string
*/
const ModalHeader = ({
  image,
  classNamesContainer,
  classNamesBackgroundImg,
  classNamesLogoRapViet,
  disableSponsor,
}) => {
  return (
    <div className={`modal-header-container w-full ${classNamesContainer}`}>
      {image && (
        <img
          className={`w-full absolute top-0 left-0 z-40 ${classNamesBackgroundImg}`}
          src={image}
          alt="Background"
        />
      )}
      <div>
        <img
          className={`z-50 object-fit w-[67%] ${classNamesLogoRapViet}`}
          src={ImgLogoATSH}
          alt="Anh Trai Say Hi Concert"
        />
      </div>
    </div>
  );
};

export default ModalHeader
